import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { LoginRoutingModule } from "./login-routing.module";
import { TemplateComponent } from "./template/template.component";
import { Error404Component } from "./error404/error404.component";
import { LoginComponent } from "./login/login.component";
import { RouterModule } from "@angular/router";
import { DeletedComponent } from "./deleted/deleted.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { LogoutComponent } from "./logout/logout.component";
import { LibrarySelectorComponent } from "./library-selector/library-selector.component";
import { PasswordResetComponent } from "./password-reset/password-reset.component";
import { ExecutePasswordResetComponent } from "./password-reset/execute-password-reset/execute-password-reset.component";
import { AutoLibrarySelectionComponent } from "./auto-library-selection/auto-library-selection.component";
import { LoadingAnimationComponent } from "../loading-animation/loading-animation.component";
import { PasswordUpdateComponent } from "./password-update/password-update.component";
import { ComponentsModule } from "src/components/components.module";

@NgModule({
  declarations: [
    TemplateComponent,
    Error404Component,
    LoginComponent,
    DeletedComponent,
    LogoutComponent,
    LibrarySelectorComponent,
    PasswordResetComponent,
    ExecutePasswordResetComponent,
    AutoLibrarySelectionComponent,
    LoadingAnimationComponent,
    PasswordUpdateComponent,
  ],
  imports: [
    CommonModule,
    LoginRoutingModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    ComponentsModule,
    CommonModule,
  ],
  exports: [TemplateComponent, LoadingAnimationComponent],
})
export class LoginModule {}
